import { render, staticRenderFns } from "./account3.vue?vue&type=template&id=6e5e5616&scoped=true"
import script from "./account3.vue?vue&type=script&lang=js"
export * from "./account3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e5616",
  null
  
)

export default component.exports